import styled from 'styled-components';

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 64px;
  background-color: white;
  padding: 20px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[400]};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 24px;
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 40px;
  font-weight: 700;
  letter-spacing: 0.17px;
  margin: 0px auto;
  padding: 0px;
  width: 60%;
`;

export const CreatedAt = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  margin: 0px auto;
  padding: 0px;
  width: 60%;
  b {
    margin-right: 128px;
  }
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.grey[100]};
  min-height: 100vh;
  padding: 20px;
`;

export const ContentContainer = styled.div`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  background-color: ${({ theme }) => theme.palette.common.white};
  width: 100%;
  height: 100%;
`;
